import React, { useState, useEffect, useRef, useCallback, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Grid, Paper, Skeleton } from '@mui/material'
import _ from "lodash"
import Header from "./layouts/Header";
import DynamicComponent from "./partials/DynamicComponent";

import Footer from "./layouts/Footer";




const PRPSPDFRoute = (props) => {
    const [loading, setLoading] = useState(true);
    const [callVI, setCallVI] = useState(false)
    useEffect(() => {
        if (window !== undefined) {
            window.scrollTo(0, 0)
        }
    }, [])
    const [searchParams] = useSearchParams();
    //const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const [viewInstance, setViewInstance] =  useState({})//useSelector(state => selectViewInstanceById(state, 'PhysicianSummary'))
    const settings = viewInstance?.settings || {}
    const dispatch = useDispatch();
    const authToken= searchParams.get("auth")
    const reportGuid= searchParams.get("vi")
    const assessmentGuid= searchParams.get("assmt")
    const VIName= searchParams.get("viName") 
    const componentRef = useRef(null);


    useEffect(() => {
        if (loading){

            const startConversion = () => {
                if (window.hiqPdfConverter) {
                    window.hiqPdfConverter.startConversion();
                }
            };
            
            // Ensure hiqPdfConverter is available and the component is ready
            if (typeof window.hiqPdfConverter !== 'undefined' && !loading) {
                startConversion();
            } else {
                // Add an event listener for when hiqPdfConverter becomes available
                window.addEventListener('hiqPdfConverterReady', startConversion);
                
                // Clean up the event listener when the component unmounts
                return () => {
                    window.removeEventListener('hiqPdfConverterReady', startConversion);
                };
            }
        }
    }, [loading]);



    useEffect(() => {
        const fetchData = async ()=>{

            setLoading(true)
            try {
                console.log('trying fetch')
                fetch('../../WsWebServicePlatform/Participant/SessionVar/Set/' + authToken + '/RESPONSE%20GUID/' + assessmentGuid+'/', {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: {
                    }
                })
                .then(response => {return response.json()})
                .then(response => {
                    console.log('did post response call', response)
                    return fetch("../../WsWebServiceWellSuite/" + "GetViewInstance/" + authToken+ "/"+reportGuid +'/', {
                        method: "GET",
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                })})
                .then(response => {
                    console.log('response2',response)
                    return response.json()
                })
                
                .then(response => {
                    console.log('response json return',response)
                    const data = response.Success ? { ReportViewInstance:response.Info[0].ViewInstanceData[0].ReportViewInstance, settings: response.Info[0].ViewInstanceData[1]} : {ReportViewInstance:{}, settings:{}}
                    setViewInstance(data)
                    setLoading(false)
                })
                
                
            } catch (error) {
                console.error(error.message)
            }
        }

        fetchData()
    }, [window.location.pathname])
    console.log('completed', viewInstance)
 
    const OrderedSections =
        viewInstance
        && viewInstance.ReportViewInstance
        && viewInstance.ReportViewInstance.ReportPage
        && viewInstance.ReportViewInstance.ReportPage[0].ReportFrame
        && [...viewInstance.ReportViewInstance.ReportPage[0].ReportFrame].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })



    return (
        <Box ref={componentRef} className="psprintcontainer">

            <Header  />
            <Grid container direction="row" spacing={2} sx={{ marginTop: '150px', marginLeft: '-12px' }} alignItems="stretch" justifyContent="center">

                {/** The idea is simple, we will send each array to a single component that will dictate its format */}
                {/** Each array will have a ComponentType attribute. [{ComponentType},{ComponentType},{ComponentType}] */}
                {/** This component type will load a specific component*/}

                {viewInstance && !loading && viewInstance.ReportViewInstance
                    && OrderedSections ? (

                    <>
                        {
                            OrderedSections.map((reportComponent, index) => {
                                return (

                                    <DynamicComponent component={reportComponent} settings={settings} delay={index} key={index} />

                                )
                            })
                        }
                        <div id="report_end" key="report_end" className="report_end" style={{height:"0%", width:"0%", position:"fixed"}}/>
                    </>
                ) : (
                    [1, 2, 3, 4, 5].map(x => {
                        return (
                            <Grid item xs={12}>
                                <Paper elevation={1} >
                                    <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "30%" }} height={0} />
                                </Paper>
                            </Grid>
                        )
                    })

                )
                }



            </Grid>
            <Footer />

        </Box>
    );



};

export default React.forwardRef(PRPSPDFRoute);